import { fetchChartPermissionsQueryOptions } from '@/api/permissionsQueryOptions';
import BoardChart from '@/components/chart/BoardChart';
import BoardHistoryChart from '@/components/chart/BoardHistoryChart';
import ChildrenChart from '@/components/chart/ChildrenChart';
import ChildrenHistoryChart from '@/components/chart/ChildrenHistoryChart';
import SectionChart from '@/components/chart/SectionChart';
import SectionDropoutChart from '@/components/chart/SectionDropoutChart';
import SectionHistoryChart from '@/components/chart/SectionHistoryChart';
import SectionJoinChart from '@/components/chart/SectionJoinChart';
import { Grid } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/charts')({
    component: ChartsComponent,
})

function ChartsComponent() {
    const permissionsQuery = useSuspenseQuery(fetchChartPermissionsQueryOptions(['sections', 'boards', 'history', 'children']))
    const permissions = permissionsQuery.data

    const readSections = permissions && permissions.filter(p => p.detail === 'sections' && p.permissions.some(a => a === 'read')).length > 0
    const readBoards = permissions && permissions.filter(p => p.detail === 'boards' && p.permissions.some(a => a === 'read')).length > 0
    const readHistory = permissions && permissions.filter(p => p.detail === 'history' && p.permissions.some(a => a === 'read')).length > 0
    const readChildren = permissions && permissions.filter(p => p.detail === 'children' && p.permissions.some(a => a === 'read')).length > 0

    return (
        <>
            <Grid container spacing={1}>
                {readSections &&
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 6
                        }}>
                        <SectionChart />
                    </Grid>
                }
                {readBoards &&
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 6
                        }}>
                        <BoardChart />
                    </Grid>
                }
                {readChildren &&
                    <Grid
                        size={{
                            xs: 12,
                        }}>
                        <ChildrenChart />
                    </Grid>
                }
            </Grid>
            <Grid container spacing={1}>
                {readHistory && readSections &&
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 6
                        }}>
                        <SectionHistoryChart />
                    </Grid>
                }
                {readHistory && readBoards &&
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 6
                        }}>
                        <BoardHistoryChart />
                    </Grid>
                }
            </Grid>
            {readHistory && readSections &&
                <Grid container spacing={1}>
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 6
                        }}>
                        <SectionJoinChart />
                    </Grid>

                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 6
                        }}>
                        <SectionDropoutChart />
                    </Grid>
                </Grid>
            }
            {readHistory && readChildren &&
                <Grid container spacing={1}>
                    <Grid
                        size={{
                            xs: 12
                        }}>
                        <ChildrenHistoryChart />
                    </Grid>
                </Grid>
            }
        </>
    )
}
